
function setCanvasBillboard(mars3d) {
  class CanvasBillboard extends mars3d.graphic.BillboardEntity {
    get text() {
      return this.style.text;
    }
    set text(val) {
      this.style.text = val;
      this._updateCanvas();
    }
  
    _mountedHook() {
      super._mountedHook();
  
      this.style.imageUrl = "static/mapconfig/img/textPnl.png";
      this.style.width = 300;
      this.style.height = 140;
  
      if (!this._canvas) {
        this._canvas = document.createElement("canvas");
        this._canvas.width = this.style.width;
        this._canvas.height = this.style.height;
      }
  
      if (!this._pngImage) {
        let img = new Image(this.style.width, this.style.height);
        img.crossOrigin = "Anonymous";
        img.src = this.style.imageUrl;
        img.onload = () => {
          this._pngImage = img;
          this._updateCanvas();
        };
      }
      this._updateCanvas();
    }
  
    _updateCanvas() {
      if (!this._pngImage || !this._canvas) {
        return;
      }
  
      let canvas = this._canvas;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(this._pngImage, 0, 0);
  
      ctx.fillStyle = "rgb(255, 255, 255)";
      ctx.font = "55px Arial";
      ctx.textBaseline = "middle";
      ctx.fillText(this.style.text, 40, canvas.height / 2);
  
      let newImg = new Image(canvas.width, canvas.height);
      newImg.src = canvas.toDataURL("image/png");
  
      this.image = newImg;
    }
  }
  mars3d.graphic.CanvasBillboard = CanvasBillboard;
}

export { setCanvasBillboard }



//////////////////
// WEBPACK FOOTER
// ./static/util/CanvasBillboard.js
// module id = null
// module chunks = 